import { Environment } from '@pegasus/config';
import { renderGTMLoader } from './gtm-loader';
import { escapeHtml } from './utils';
export const renderGTM = (tagCode) => {
    const code = escapeHtml(tagCode);
    return `
        <script>
            var webtrekk, webtrekkV3;
            if (typeof window.dataLayer == "undefined") { dataLayer = []; }
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="//www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f); })(window,document,"script","dataLayer","${code}");
        </script>
        <noscript>
            <iframe src="//www.googletagmanager.com/ns.html?id=${code}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
        </noscript>`;
};
export const renderWebviewApiTracking = (webviewOs) => {
    return `
        <script>
            if (typeof window.dataLayer == "undefined") {
                window.dataLayer = [];
            }
            window.zlConsole = window.zlConsole || console;
            const oldPush = dataLayer.push;
            dataLayer.push = function () {
                var args = arguments[0];
                var isGA4Event = typeof args.event === 'string' && args.event.startsWith('GA4-');
                args.client_type = isGA4Event ? 'mobile-${webviewOs}' : '${webviewOs}-app';
                var payload = Object.keys(args).reduce(function(result, key) {
                    return result + (result ? "&" : "?") +  (encodeURIComponent(key) + "=" + encodeURIComponent(args[key]));
                },'');

                if (!isGA4Event) {
                    try {
                        fetch("/tracking"+payload, {
                            credentials: "same-origin"
                        }).catch(function(e) {
                            window.zlConsole.error(e);
                        });
                    } catch(e) {
                        window.zlConsole.error(e);
                    }
                }

                oldPush.apply(
                    window.dataLayer,
                    arguments
                );
            }
        </script>`;
};
export const renderTracking = ({ enabled, environment = Environment.PRODUCTION, salesChannel, trackingMode, renderCustomWebviewTracking, webviewOs, }) => {
    if (!enabled) {
        return '';
    }
    if (webviewOs && webviewOs !== 'web') {
        if (renderCustomWebviewTracking) {
            return renderCustomWebviewTracking();
        }
        if (trackingMode === 'in_web') {
            /**
             * For the `in_web` tracking mode, we should
             * - track GA4 events within the web view with `dataLayer.push`
             * - track UA360 with the `/tracking` request intercepted by apps
             */
            const gtmLoader = renderGTMLoader({ environment, salesChannel, trackingMode });
            const webviewLoader = renderWebviewApiTracking(webviewOs);
            return gtmLoader + webviewLoader;
        }
        return renderWebviewApiTracking(webviewOs);
    }
    return renderGTMLoader({ environment, salesChannel });
};
//# sourceMappingURL=gtm.js.map